<template>
  <div class="row">
    <b-col sm="auto" xl="4">
      <client-photo-card
        :purchase_sum="client.purchase_sum"
        :photopath="client.photopath"
        :client-id="client.id"
        :club-days="getDate() + ' днів'"
      >
      </client-photo-card>
    </b-col>
    <b-col sm="auto" xl="4">
      <b-card class="shadow mt-2">
        <client-info-inputs
          v-bind:client-data="client"
          v-on:refresh="forwardEvent"
          v-on:showAlert="showAlert"
          v-bind:read-only-inputs="inputState"
        >
        </client-info-inputs>
      </b-card>
    </b-col>
    <b-col sm="auto" xl="4" class="noteBox">
      <b-card class="shadow mt-2">
        <client-notes
          v-bind:notes="client.notes"
          v-on:refresh="forwardEvent"
          v-on:showAlert="showAlert"
          v-bind:client-id="client.id"
        />
      </b-card>
    </b-col>
  </div>
</template>

<script>
import moment from "moment";
import ClientPhotoCard from "@/components/Profile/ClientPhotoCard";
import ClientInfoInputs from "@/components/ClientPage/ClientInfoInputs";
import ClientNotes from "@/components/ClientPage/ClientNotes";

export default {
  name: "ClientProfile",
  components: {
    ClientInfoInputs,
    ClientPhotoCard,
    ClientNotes,
  },
  props: {
    client: Object,
    inputState: Boolean,
  },
  methods: {
    getDate: function () {
      return Math.abs(
        moment.duration(moment(this.client.firstday).diff(moment())).asDays(),
      ).toFixed(0);
    },
    forwardEvent() {
      this.$emit("refresh");
    },
    showAlert(text, color) {
      this.$emit("showAlert", text, color);
    },
  },
};
</script>

<style scoped>
.noteBox {
  overflow: auto;
  max-height: 400px;
}
</style>
